function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.62917 12.6815H3.3705C2.98184 12.6815 2.6665 12.3661 2.6665 11.9775V7.05214C2.6665 6.66348 2.98184 6.34814 3.3705 6.34814H4.62917C5.01784 6.34814 5.33317 6.66348 5.33317 7.05214V11.9775C5.33317 12.3661 5.01784 12.6815 4.62917 12.6815V12.6815Z",
  stroke: "#132C67",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.3335 7.06281L7.76616 3.89548C8.21883 3.30548 9.10283 3.29081 9.5755 3.86481V3.86481C9.75216 4.07881 9.84816 4.34815 9.84816 4.62548V6.80615H11.9122C12.3128 6.80615 12.6868 7.00615 12.9095 7.33881L13.1288 7.66615C13.3255 7.96015 13.3828 8.32615 13.2848 8.66548L12.3788 11.8135C12.2308 12.3275 11.7608 12.6815 11.2262 12.6815H7.0335C6.70016 12.6815 6.3815 12.5428 6.15483 12.2988L5.3335 11.4148",
  stroke: "#132C67",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.7b2711d6.svg";
export { ForwardRef as ReactComponent };